import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=71ed9bd2&scoped=true"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"
import style0 from "./Column.vue?vue&type=style&index=0&id=71ed9bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed9bd2",
  null
  
)

export default component.exports